import { Box, Card, MenuItem, Pagination, Select, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import PrintDownloadButton from '../../common/button/printDownloadButton'
import { PiFileXls } from 'react-icons/pi';
import Cookies from 'js-cookie'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import { Bar } from 'react-chartjs-2';
import { useNavigate } from 'react-router-dom';
import DataTable from '../../common/dataTable';
import { useDispatch, useSelector } from 'react-redux';
import objectionTrackerActions from '../../redux/objectionTracker/actions';
import masterActions from '../../redux/master/actions';
import MauvelousPrimaryButton from '../../common/button/mauvelousPrimaryButton';
import TablePagination from '../../common/tablePagination';
import DataTableModified from '../../common/dataTableModified';

const Index = () => {



    
  const [rows, setRows] = React.useState( []);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [currentPage, setCurrentPage] = React.useState(1);

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(event.target.value);
    setCurrentPage(1);
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };
    const navigate = useNavigate()
    const dispatch = useDispatch();
    
    const [selectedQuestion, setSelectedQuestion] = useState('');
    const [selectedCourseId, setSelectedCourseId] = useState(null);
    const [showTable, setShowTable] = useState(false);





    const objQuestionDetailsCount = useSelector((state) => state.objectionTrackerReducer?.objQuestionDetailsCount);
    const filteredobjQuestionDetailsCount = objQuestionDetailsCount?.filter((item)=>item?.courseid == selectedCourseId )
    const sortedobjQuestionDetailsCount = filteredobjQuestionDetailsCount?.sort((a,b)=>parseInt(a?.questionid) - parseInt(b?.questionid))
    const { courseList,courseListAdmin } = useSelector((state) => state.masterReducer);
    const { backofficeTokenDetails } = useSelector((state) => state.authReducer);


    const courseIds = courseListAdmin?.all?.length 
  ? courseListAdmin.all[0]?.courses?.split(',').map(Number) 
  : [];


useEffect(()=>{
    setRows(sortedobjQuestionDetailsCount)

},[sortedobjQuestionDetailsCount])


const filteredCourseList = courseList?.all?.filter((item) =>
  courseIds?.includes(Number(item?.courseid)) // Ensure both are numbers
);

    const handleNavigate = () => {
        navigate(`/${Cookies.get("mhet_mst_project")}/view-objections?cid=${selectedCourseId}`)
    }
    const handleView = () => {
        setShowTable(true)
    }



    const handleSelectCourse = (courseid) => {
        setSelectedCourseId(courseid);
        setSelectedQuestion('');
        setShowTable(false);
        dispatch({
          type: objectionTrackerActions.GET_OBJECTION_QUESTION_DETAILS,
          payload: { courseid },
        });
      };


    useEffect(() => {
        dispatch({ type: masterActions?.GET_COURSE_LIST });

        
        dispatch({ type: masterActions.GET_COURSE_LIST_BY_ADMIN,payload:{id:backofficeTokenDetails?.id} });
      }, [backofficeTokenDetails]);

useEffect(()=>{

    dispatch({
        type: objectionTrackerActions?.GET_OBJECTION_QUESTION_DETAILS_COUNT
      });
      sessionStorage.removeItem("selectedCourseId");
      sessionStorage.removeItem("selectedQuestion");
},[])
    



    const columnData = [
        { name: `Question Id ( ${filteredobjQuestionDetailsCount?.length} )`, accessor: 'questionid' },
        { name: `Objection Count ( ${filteredobjQuestionDetailsCount?.reduce((p,c)=>{return parseInt(p)+parseInt(c?.total_count)},0)} )`, accessor: 'total_count' },
        { name: `Approved Count ( ${filteredobjQuestionDetailsCount?.reduce((p,c)=>{return parseInt(p)+parseInt(c?.approved_count)},0)} )`, accessor: 'approved_count' },
        { name: `Rejected Count ( ${filteredobjQuestionDetailsCount?.reduce((p,c)=>{return parseInt(p)+parseInt(c?.not_approved_count)},0)} )`, accessor: 'not_approved_count' },
        { name: `Yet to view Count ( ${filteredobjQuestionDetailsCount?.reduce((p,c)=>{return parseInt(p)+parseInt(c?.null_count)},0)} )`, accessor: 'null_count' },
        // { name: 'Reference Details', accessor: 'referenceid' },
        // { name: 'Action', accessor: 'action' }
      ];

    return (
        <>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: 2 }}>
                {/* <Typography pb={1} variant="h5"  >Dashboard | Objection Tracker</Typography> */}

            </Box>
            <Box sx={{ display: 'flex', justifyContent: "space-between", alignItems: 'center', padding: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, justifyContent: "center" }}>
  <Select
    value={selectedCourseId || 0}
    onChange={(e) => handleSelectCourse(e.target.value)}
    size="small"
    MenuProps={{
      PaperProps: {
        style: {
          maxHeight: 200, // Set a max height for scroll
          overflowY: "auto",
        },
      },
    }}
  >
    <MenuItem disabled value={0}>Course Name</MenuItem>
    {filteredCourseList?.map((item) => (
      <MenuItem key={item.courseid} value={item.courseid}>
        {item.coursename}
      </MenuItem>
    ))}
  </Select>

  <MauvelousPrimaryButton title="View" disabled={selectedCourseId == null} handleClick={handleView} />
</Box>



                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                    {/* <PrintDownloadButton name="Download Objection" startIcon={<PiFileXls />} /> */}
                    <PrintDownloadButton name="View Objections" handleSubmit={handleNavigate} />
                </Box>
            </Box>
         
           {showTable &&
           <>
           {/* <DataTable keys={columnData} values={sortedobjQuestionDetailsCount} /> */}
           <DataTableModified keys={columnData} values={sortedobjQuestionDetailsCount} />
           </>
           
           }
        </>
    )
}

export default Index
